import { Box, Grid2, Stack, Typography, useTheme } from "@mui/material";
import React from "react";
import PageTitle from "../../../components/Common/PageTitle";
import { quickLinksData } from "../../../assets/data/data";
import { Check } from "@mui/icons-material";

const QuickLinkCard = ({ item }) => {
  const theme = useTheme();
  return (
    <Grid2 item size={{ xs: 12 }}>
      <Stack
        direction="row"
        spacing={2}
        sx={{
          borderBottom: `1px solid rgba(73,42,24, 0.5)`,
          py: 2,
        }}
      >
        <Check sx={{ color: theme.palette.text.primary }} />
        <Typography
          sx={{
            fontFamily: "'Quicksand', sans-serif",
            fontSize: "18px",
            color: theme.palette.text.primary,
          }}
        >
          {item.text}
        </Typography>
      </Stack>
    </Grid2>
  );
};

const QuickLinks = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "95%",
        mx: "auto",
        mt: 3,
      }}
    >
      <PageTitle
        title={"Quick Links - Custom Navigation"}
        text={
          "We’ve made it easy for you to personalize your experience! Simply drag any item from the navigation list on the left to your dashboard or workspace. This allows you to:"
        }
        noIcon
      />

      <Box sx={{ mt: 3 }}>
        {quickLinksData.map((item, index) => (
          <>
            <QuickLinkCard key={item.id} item={item} />

            {index === 3 && (
              <Grid2 item size={{ xs: 12 }}>
                <Typography
                  sx={{
                    fontFamily: "'Quicksand', sans-serif",
                    fontWeight: "bold",
                    fontSize: "18px",
                    color: theme.palette.text.primary,
                    mt: 4,
                    mb: 2,
                  }}
                >
                  Take control of your learning and growth by setting up your
                  dashboard to best suit your needs!
                </Typography>
              </Grid2>
            )}
          </>
        ))}
      </Box>
    </Box>
  );
};

export default QuickLinks;
